export default __webpack_public_path__ + "static/media/gallery-wip-handle_02.5a05e772.jpg";